module.exports = __webpack_public_path__ + "media/src/application/media/bg-img-3548711e23e3c9e5c06421a8c0fae7ad.webp";